import React, { useState, useEffect } from "react";
import { Button, Dropdown, Table, Modal } from "react-bootstrap";
import axios from "axios";
import EmployeeForm from "./EmployeeForm";

const BASE_URL = 'https://whapi.infosware-test.in'; // Define base URL

function Employees() {
  const [view, setView] = useState("list");
  const [employeeId, setSelectedEmployee] = useState(null);
  const [employees, setEmployees] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [employeeToDelete, setEmployeeToDelete] = useState(null);

  useEffect(() => {
    fetchEmployees();
  }, []);

  const fetchEmployees = () => {
    axios
      .get(`${BASE_URL}/employees`)
      .then((response) => {
        setEmployees(response.data);
      })
      .catch((error) => {
        console.error("Error fetching employees:", error);
      });
  };

  const handleNewEmployee = () => setView("add");

  const handleEditEmployee = (employee) => {
    setSelectedEmployee(employee.id);
    setView("edit");
  };

  const handleDeleteEmployee = (id) => {
    setEmployeeToDelete(id);
    setShowDeleteModal(true);
  };

  const confirmDeleteEmployee = () => {
    axios
      .delete(`${BASE_URL}/delete-employee/${employeeToDelete}`)
      .then(() => {
        setEmployees(
          employees.filter((employee) => employee.id !== employeeToDelete)
        );
        setShowDeleteModal(false);
      })
      .catch((error) => {
        console.error("Error deleting employee:", error);
      });
  };

  const cancelDeleteEmployee = () => {
    setShowDeleteModal(false);
  };

  const formatPermissions = (permissions) => {
    if (Array.isArray(permissions)) {
      return permissions.join();
    }
    return permissions;
  };

  const renderContent = () => {
    switch (view) {
      case "list":
        return (
          <div className="p-4">
            <div className="d-flex justify-content-between align-items-center mt-4 mb-4">
              <h3>Employee List</h3>
              <Button variant="primary" onClick={handleNewEmployee}>
                New Employee
              </Button>
            </div>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Id</th>
                  <th>Name</th>
                  <th>User Name</th>
                  <th>Password</th>
                  <th>Permissions</th>
                </tr>
              </thead>
              <tbody>
                {employees.map((employee, index) => (
                  <tr key={employee.id}>
                    <td>{index + 1}</td>
                    <td>{employee.name}</td>
                    <td>{employee.username}</td>
                    <td>{employee.password}</td>
                    <td>{formatPermissions(employee.permissions)}</td>
                    <td>
                      <div className="d-flex justify-content-end align-items-center gap-4 p-1">
                        <Dropdown>
                          <Dropdown.Toggle variant="primary">
                            Actions
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.Item
                              className="text-success"
                              onClick={() => handleEditEmployee(employee)}>
                              Edit
                            </Dropdown.Item>
                            <Dropdown.Item
                              className="text-danger"
                              onClick={() => handleDeleteEmployee(employee.id)}>
                              Delete
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        );
      case "add":
        return (
          <EmployeeForm onCancel={() => setView("list")} onSave={onSave} />
        );
      case "edit":
        const employeeToEdit = employees.find((emp) => emp.id === employeeId);
        return (
          <EmployeeForm
            employee={employeeToEdit}
            onCancel={() => setView("list")}
            onSave={onSave}
          />
        );
      default:
        return null;
    }
  };

  const onSave = (newEmployeeData) => {
    if (view === "edit") {
      setEmployees(
        employees.map((emp) => {
          if (emp.id === employeeId) {
            return {
              ...emp,
              ...newEmployeeData,
              password: newEmployeeData.password || emp.password, // Keep the old password if not changed
            };
          }
          return emp;
        })
      );
      setSelectedEmployee(null); // Clear the selected employee after editing
    } else {
      setEmployees([...employees, newEmployeeData]);
    }
    setView("list"); // Close the form and render employees list
    fetchEmployees(); // Fetch the updated list of employees
  };

  return (
    <div>
      {renderContent()}

      {/* Delete confirmation modal */}
      <Modal show={showDeleteModal} onHide={cancelDeleteEmployee}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete this employee?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={cancelDeleteEmployee}>
            Cancel
          </Button>
          <Button variant="danger" onClick={confirmDeleteEmployee}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default Employees;
